import { useSyncExternalStore } from 'react';

/**
 * A media query as state.
 *
 * Home renders a different screen on a desktop, not the same screen restyled —
 * a phone answers "what do I do today", a laptop shows the wall chart. That
 * decision has to reach JS, so CSS `lg:` classes can't make it alone: rendering
 * both trees and hiding one would double the work and give two live drag
 * handlers for every row.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const list = matchMediaOrNull(query);
      if (!list) return () => undefined;
      list.addEventListener('change', notify);
      return () => list.removeEventListener('change', notify);
    },
    () => matchMediaOrNull(query)?.matches ?? false,
    // Server/prerender has no viewport; assume the phone, which is the case
    // the app is designed around.
    () => false,
  );
}

/** Absent in jsdom, and in any non-browser render. Both mean "phone". */
function matchMediaOrNull(query: string): MediaQueryList | null {
  return typeof window.matchMedia === 'function' ? window.matchMedia(query) : null;
}

/** Tailwind's `lg`. The width where a month of columns and a nav rail fit. */
export const DESKTOP = '(min-width: 1024px)';
